import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';

import ButtonBack from '../../components/ButtonBack';
import SelectBox from '../../components/SelectBox';
import Text from '../../components/Text';
import Button from '../../components/Button';
import Spacing from '../../components/Spacing';

import { Container } from './styles';
import { SupportText } from '../../components/Support';
import { loadEmails } from '../../redux/ducks/emails';
import Loading from '../../components/Loading';
import { setSecurityCredential } from '../../redux/ducks/main';
import { userExists } from '../../services/user';

const getTextsByTotalEmails = total => {
  if(total > 1) {
    return {
      title: (
        <>
          Este CPF/CNPJ possui mais de um e-mail cadastrado.
          <br/>
          Escolha o e-mail que você deseja fazer o login:
        </>
      ),
      register: 'Não possuo acesso aos e-mails listados',
    }
  }

  return {
    title: (
      <>
        Este CPF/CNPJ já possui um e-mail cadastrado. 
        <br/> 
        Por favor, confirme para continuar comprando.
      </>
    ),
    register: 'Não possuo acesso ao e-mail',
  }
}

function ListEmails() {
  const history = useHistory();
  const dispatch = useDispatch();

  const { emails, loading } = useSelector(state => state.emails);

  const [selectedEmail, setSelectedEmail] = useState(null);
  const [loadingSettingEmail, setLoadingSettingEmail] = useState(false);

  const handleContinue = async () => {
    if (selectedEmail) {
      setLoadingSettingEmail(true);
      try {
        await userExists({ security_email: selectedEmail.key });
      } catch {}
      dispatch(
        setSecurityCredential({ 
          value: selectedEmail.key, 
          publicValue: selectedEmail.email, 
          document: history.location.state.document 
        }));
      history.push('/login/form');
      setLoadingSettingEmail(false);
    }
  }

  useEffect(() => {
    if (history.location.state.document !== undefined) {
      if (emails === null) {
        dispatch(loadEmails(history.location.state.document))
      }
    } else {
      history.goBack();
    }
  }, [emails, history, dispatch]);  

  useEffect(() => {
    if (!loading && Array.isArray(emails) && emails.length === 0) {
      history.replace('/register', { document: history.location.state.document });
    }
    if (!loading && Array.isArray(emails) && emails.length === 1) {
      const [selected] = emails;
      if (selected?.value.hasPassword) {
        dispatch(
          setSecurityCredential({ 
            value: selected?.value.key, 
            publicValue: selected?.label,
            document: history.location.state.document 
          }));
        history.replace('/login/form');
      }
    }
  }, [dispatch, emails, history, loading]);

  const texts = getTextsByTotalEmails(emails?.length)
  
  return (
    <>
      <ButtonBack onClick={() => history.goBack()} />
      <Container>      
        {loading || emails === null ? (
          <Loading />
        ) : (
          <>
            {loadingSettingEmail && <Loading />}
            <Text variant="titulo2" align="left">
              {texts.title}
            </Text>
            <Spacing size={14} />
            <SelectBox options={emails} onChange={setSelectedEmail} />
            <Spacing size={14} />
            <Button variant="buttonPrimary" disabled={!selectedEmail} onClick={handleContinue} text="Entrar" />
            <SupportText />
          </>
        )}
      </Container>
    </>
  )
}

export default ListEmails;
